import './common.js';

import './libs/menu-complex.js';
import './libs/imageslider-complex.js';

import '../scss/complex_gallery.scss';